import { customEvent } from "goi_common";
import { ArrowRightIcon } from "@/components/DirectionsIcons";

type LeadCTAPosition = "middle" | "bottom";

interface DirectionsLeadCTAProps {
  parlorId: number;
  companyName: string;
  position: LeadCTAPosition;
}

export const DirectionsLeadCTA = ({
  parlorId,
  companyName,
  position,
}: DirectionsLeadCTAProps) => {
  const href = `${process.env.NEXT_PUBLIC_PLATFORM_WEB_URL}/match/parlor-requests/${parlorId}/?utm_source=parlor_goi&utm_campaign=directions&utm_content=${position}_cost`;

  const trigger =
    position === "middle" ? "btn_cta_lead_middle" : "btn_cta_lead_bottom";

  return (
    <section
      className={`dr-leadcta dr-leadcta--${position}`}
      aria-labelledby={`dr-leadcta-${position}-title`}
    >
      <div className="dr-leadcta__inner">
        <h2 id={`dr-leadcta-${position}-title`} className="dr-leadcta__title">
          {`${companyName} 장례 비용도 무료로 확인하세요`}
        </h2>
        <p className="dr-leadcta__lede">
          {`${companyName}의 빈소 사용료, 장례 전체 예상 비용을 고이장례연구소에서 24시간 무료로 안내드립니다.`}
        </p>
        <a
          className="dr-btn dr-btn--white dr-btn--lg"
          href={href}
          onClick={() =>
            customEvent({
              newGtm: {
                path: "prlr_directions",
                trigger_and_target: trigger,
                properties: {
                  parlor_id: parlorId,
                  cta_type: "cost",
                  cta_position: position,
                },
              },
            })
          }
        >
          <span className="dr-leadcta__cta-stack">
            <span className="dr-leadcta__cta-eyebrow">{companyName}</span>
            <span className="dr-leadcta__cta-main">
              비용 알아보기
              <ArrowRightIcon size={16} style={{ marginLeft: 6 }} />
            </span>
          </span>
        </a>
      </div>
    </section>
  );
};
